/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 Open Assessment Technologies SA;
 */

import { hasPlaceholder } from '../blocks/util/placeholder.js';

/**
 * Validate that node related with default layout
 * @returns {boolean}
 */
export function validate() {
    // any node basically has default layout
    return true;
}

/**
 * Filter nodes to find one which participates in creating layout
 * @param {Node} node - the DOM node
 * @returns {boolean}
 */
export function filterBlock(node) {
    //there is a placeholder in that branch,
    //or node is a table - `.\parser\mapper\table.js` needs a container with children that can be extracted
    return hasPlaceholder(node.textContent) || node.nodeName === 'TABLE';
}

/**
 * Name of static component which will be used for rendering node
 * @param {Node} node - the DOM node
 * @returns {bool|string}
 */
export function getElementName(node) {
    return node.nodeName.toLowerCase();
}
